import { render, staticRenderFns } from "./rgmlList.vue?vue&type=template&id=567d6576&scoped=true&"
import script from "./rgmlList.vue?vue&type=script&lang=js&"
export * from "./rgmlList.vue?vue&type=script&lang=js&"
import style0 from "./rgmlList.vue?vue&type=style&index=0&id=567d6576&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567d6576",
  null
  
)

export default component.exports